import { render } from "./RatingsOptions.vue?vue&type=template&id=6ae3595e"
import script from "./RatingsOptions.vue?vue&type=script&lang=js"
export * from "./RatingsOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__